import Icon from "@material-ui/icons/School";
import SchoolList from "./SchoolList";
import SchollCreate from "./SchoolCreate";
import SchoolEdit from "./SchoolEdit";
import SchoolShow from "./SchoolShow";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "schools",
  create: SchollCreate,
  list: SchoolList,
  show: SchoolShow,
  edit: SchoolEdit,
  icon: Icon,
};
